// import palette from "./palette"
import { customTheme } from ".";
import { drawerWidth } from "../../../portal/src/app/constants";
import palette from "../theme/palette";

const {
  blueDarkOne,
  blueDark,
  blackThree,
  white,
  blue,
  blueOne,
  blackOne,
  primary: { main: primaryMain },
  blackTwo,
  blackSix,
} = palette;

export const flexCenter = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

export const lockStyle = {
  position: "absolute",
  left: "0",
  bottom: "27px",
  zIndex: "9999",
};

export const StepperContentWrapper = {
  ...flexCenter,
  height: "calc(100vh - 121px)",
  width: "100%",
  flexDirection: "column",
  overflow: "auto",

  // On mobile the step content is short, so centring it in a full-height box
  // left a large blank gap under the stepper — sit it at the top instead.
  [customTheme.breakpoints.down("md")]: {
    height: "auto",
    justifyContent: "flex-start",
    px: 1,
    py: 2,
  },
};

export const BeforeStepperContentWrapper = {
  ...flexCenter,
  height: "calc(100vh - 21px)",
  width: "100%",
  flexDirection: "column",
};

export const BeforeStepperContentWrapperMobile = {
  ...flexCenter,
  mt: "150px",
  width: "100%",
  flexDirection: "column",
};

export const InfoAlert = {
  ...flexCenter,
  backgroundColor: blueDark,
  color: blueDarkOne,
  fontSize: "14px",
  borderRadius: "8px",
};

export const StepperStep = {
  paddingTop: "40px",

  [customTheme.breakpoints.down("md")]: {
    paddingTop: "0px",
    paddingBottom: "40px",
    marginTop: "70px",
  },
};

// The mobile logout bar now sits in flow above the stepper, so StepperStep's
// 70px top margin (which reserved space for a fixed bar) is replaced by a small
// 12px breathing gap under the logout icon. The 40px bottom padding also left
// too big a gap before the step content (most visibly the billing step's back
// arrow), so mobile keeps a tighter 12px there too.
export const onBoardingStepperStyle = {
  ...StepperStep,

  [customTheme.breakpoints.down("md")]: {
    paddingTop: "0px",
    paddingBottom: "12px",
    marginTop: "12px",
  },
};

// Inline auth links ("Forgot Password?", "Get a Membership", "Login") — one
// weight for all of them, so no page ends up half a step lighter.
export const authLinkStyle = {
  color: primaryMain,
  fontWeight: "700",
};

export const authInlineLinkStyle = {
  ...authLinkStyle,
  marginLeft: "5px",
};

// Get Started logo, mobile only — the onboarding sidebar carries the branding on
// desktop, so on a phone the screen opened with no logo at all.
export const getStartedMobileLogoWrapper = {
  textAlign: "center",
  mb: 2,
};

export const getStartedMobileLogo = {
  width: "98px",
  height: "105px",
};

// Centres a PageHeading inside the auth card: textAlign handles the title (and
// any wrapped subtitle lines), the child selector centres the subtitle row,
// which PageHeading lays out as a flex row.
export const authHeadingCentered = {
  textAlign: "center",

  "& > div": { justifyContent: "center" },
};

// "Back to Login" text button under the forgot-password / email-sent screens.
// The arrow icon defaults to color="inherit", so it turns blue along with the
// label.
export const backToLoginButton = {
  color: primaryMain,
  mt: "24px",
  textTransform: "none",
};

// Right-aligned "Forgot Password?" row above the submit button, shared by the
// portal and admin login forms.
export const forgotPasswordRow = {
  display: "flex",
  alignItems: "flex-end",
  justifyContent: "flex-end",
};

export const LinkStyle = {
  color: blackThree,
  textDecoration: "underline",
  marginLeft: "5px",
  cursor: "pointer",
  mr: 0.5,
  fontSize: "14px",

  [customTheme.breakpoints.down(394)]: {
    fontSize: "12px",
  },
};

export const billingCardWrapper = {
  borderRadius: "10px",
  backgroundColor: white,
  position: "relative",
  height: "100%",
  boxShadow: "0px 16px 32px -4px rgba(145, 158, 171, 0.3)",
  padding: "30px 40px 15px 40px",
  textAlign: "center",
};

export const billingWrapper = {
  boxShadow:
    "0px 12px 24px -4px rgba(145, 158, 171, 0.12), 0px 0px 2px 0px rgba(145, 158, 171, 0.20)",
  borderRadius: "16px",
  padding: "24px",
  position: "relative",
};

export const PaymentWrapper = {
  position: "relative",
  display: "flex",
  justifyContent: "center",
  width: "130px",
  margin: "auto",
};

export const PinInputStyle = {
  backgroundColor: "transparent",
  paddingLeft: 15,
  fontSize: 16,
  borderRadius: "4px",
  padding: "16.5px 14px",
  width: "100%",
  border: "1px solid rgba(0, 0, 0, 0.2)",
};

export const DashboardHeaderStyle = {
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: "600",
  color: blackOne,

  "&.active": {
    color: primaryMain,
    backgroundColor: "transparent",
  },

  [customTheme.breakpoints.down("lg")]: {
    paddingX: "4px",
    fontSize: "13px",
  },
};

// Same nav item look as the header, but larger type for the mobile drawer where
// there is room and the smaller header sizes are hard to tap.
export const mobileDrawerMenuItemStyle = {
  ...DashboardHeaderStyle,
  fontSize: "16px",

  [customTheme.breakpoints.down("lg")]: {
    paddingX: "4px",
    fontSize: "20px",
  },
};

export const reverifyAlertStyle = {
  alignItems: "center",
};

// Dashboard "Action Required" phone re-verify banner, tightened for mobile so
// the title, body copy and action button fit without wrapping awkwardly.
export const reverifyAlertMobileStyle = {
  ...reverifyAlertStyle,
  fontSize: "12px",

  "& .MuiAlertTitle-root": {
    fontSize: "13px",
  },
};

export const reverifyAlertButtonMobileStyle = {
  fontSize: "11px",
  whiteSpace: "nowrap",
};

export const AddContactWrapper = {
  padding: "40px 0",
  position: "relative",
  borderRadius: "16px",
  backgroundColor: "white",
  boxShadow:
    "0px 12px 24px -4px rgba(145, 158, 171, 0.12), 0px 0px 2px 0px rgba(145, 158, 171, 0.20)",
};

export const ChipStyle = {
  fontSize: "12px",
  color: blue,
  backgroundColor: blueOne,
  borderRadius: "4px",
  fontWeight: "700",
};

export const tabsWrapper = {
  marginTop: "1rem",
  width: "100%",
};

export const tabsSticky = {
  borderBottom: 1,
  borderColor: "divider",
  position: "sticky",
  top: "0px",
  backgroundColor: palette.white,
  zIndex: "100",

  [customTheme.breakpoints.down("md")]: {
    position: "relative",
    top: "0",
  },
};

export const userDetailsWrapper = {
  padding: "24px",
  maxWidth: 730,
  width: "100%",
  borderRadius: "16px",
  boxShadow:
    "0px 12px 24px -4px rgba(145, 158, 171, 0.12), 0px 0px 2px 0px rgba(145, 158, 171, 0.20);",
};

export const securityPinWrapper = {
  "& .pincode-input-container": {
    padding: "10px 0 0 0 !important",
  },
};

export const listItemWrapper = {
  "& .MuiMenu-paper": {
    boxShadow:
      "-20px 20px 40px -4px rgba(145, 158, 171, 0.24), 0px 0px 2px 0px rgba(145, 158, 171, 0.24);",
    maxHeight: "250px !important",
    borderRadius: "12px",

    "& .MuiList-root": {
      boxShadow: "0px 20px 40px -4px rgba(145, 158, 171, 0.16);",
      padding: "0",
      border: "none",

      "& .MuiMenuItem-root": {
        borderBottom: "1px solid #E5E8EB",
        padding: "15px",
        fontSize: "14px",
        color: blackOne,
      },
    },
  },
};

export const backDropStyle = {
  ...flexCenter,
  position: "fixed",
  zIndex: "99999",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  height: "100vh",
  top: "0",
  width: "100%",
  left: "0",
};

export const UserDetailHeading = {
  textTransform: "uppercase",
  color: blackTwo,
  pb: "16px",
};

export const ContactDetailHeading = {
  textTransform: "uppercase",
  color: blackTwo,
};

export const termsConditionsModalStyle = {
  "& li , a": {
    wordBreak: "break-word",
  },
};

export const customerListingWrapper = {
  borderRadius: "16px",
  boxShadow:
    "0px 12px 24px -4px rgba(145, 158, 171, 0.12), 0px 0px 2px 0px rgba(145, 158, 171, 0.20)",
  padding: "24px",

  [customTheme.breakpoints.down("xs")]: {
    padding: "24px 10px",
  },
};

export const mobileDrawerStyle = {
  display: { xs: "block", md: "none" },
  "& .MuiDrawer-paper": {
    boxSizing: "border-box",
    width: drawerWidth,
  },
};

export const paginationButtonStyle = {
  [customTheme.breakpoints.down("sm")]: {
    "& button": {
      fontSize: "12px",
      minWidth: "27px",
      height: "27px",
    },
  },
};

export const toolbarStyle = {
  padding: "16px",
  maxWidth: "1400px",
  width: "100%",
  margin: "auto",
  justifyContent: "space-between",
};

export const PromoCodeStyle = {
  borderRadius: "4px",
  border: `1px dashed ${primaryMain}`,
  backgroundColor: blackSix,
  fontSize: "18px",
  color: primaryMain,
  padding: "10px 20px",
};

export const emptyBox = {
  flexDirection: "column",
  width: "100%",
  ...flexCenter,
};

export const dataPickerStyle = {
  "& .MuiStack-root": {
    "& .MuiTextField-root": {
      width: "100% !important",
    },
  },
};

// In normal flow so the logout bar sits above the stepper and scrolls away with
// the page instead of staying pinned over the content.
export const onBoardingMobile = {
  textAlign: "center",
  width: "100%",
};

/* Frosted card + drifting gradient backdrop, mirroring the API landing page at
   packages/api/public/landing/index.html so portal auth matches the root page. */
export const authBackdropStyle = {
  position: "fixed",
  inset: 0,
  zIndex: -1,
  backgroundColor: "#F4F6F8",
  overflow: "hidden",
  pointerEvents: "none",

  "@keyframes authDriftA": {
    to: { transform: "translate3d(8vmax, 6vmax, 0) scale(1.12)" },
  },

  "@keyframes authDriftB": {
    to: { transform: "translate3d(-7vmax, -5vmax, 0) scale(1.08)" },
  },

  "&::before, &::after": {
    content: '""',
    position: "absolute",
    borderRadius: "50%",
    filter: "blur(90px)",
    opacity: 0.55,
  },

  "&::before": {
    width: "60vmax",
    height: "60vmax",
    top: "-22vmax",
    left: "-18vmax",
    background:
      "radial-gradient(circle at 30% 30%, #9BD3FF, rgba(155, 211, 255, 0) 70%)",
    animation: "authDriftA 22s ease-in-out infinite alternate",
  },

  "&::after": {
    width: "55vmax",
    height: "55vmax",
    bottom: "-24vmax",
    right: "-16vmax",
    background:
      "radial-gradient(circle at 60% 60%, #C9E7FF, rgba(201, 231, 255, 0) 70%)",
    animation: "authDriftB 26s ease-in-out infinite alternate",
  },

  "@media (prefers-reduced-motion: reduce)": {
    "&::before, &::after": { animation: "none" },
  },
};

export const authCardWrapper = {
  ...flexCenter,
  flexDirection: "column",
  width: "100%",
  paddingX: "16px",
};

export const authCardStyle = {
  width: "100%",
  maxWidth: "500px",
  // Auto margins centre the card but collapse to 0 once it outgrows a scrolling
  // wrapper, so a tall card stays scrollable to the top instead of being clipped.
  marginY: "auto",
  // Without this the card shrinks below its content height inside a column flex
  // wrapper, so the overflow is clipped rather than scrolled.
  flexShrink: 0,
  padding: "44px 36px 36px",
  border: "1px solid rgba(255, 255, 255, 0.7)",
  borderRadius: "24px",
  background: "rgba(255, 255, 255, 0.82)",
  backdropFilter: "blur(18px)",
  WebkitBackdropFilter: "blur(18px)",
  boxShadow: "0 24px 60px -20px rgba(12, 83, 183, 0.28)",

  [customTheme.breakpoints.down(420)]: {
    padding: "34px 22px 26px",
    borderRadius: "20px",
  },
};

// Sign up carries more fields, so it gets a wider card in a scrollable wrapper.
// justifyContent stays at flex-start — centring here would push the top of an
// overflowing card out of reach; the card's auto margins centre it instead.
export const authCardScrollWrapper = {
  ...authCardWrapper,
  height: "100%",
  overflowY: "auto",
  justifyContent: "flex-start",
  paddingY: "16px",
};

export const authCardWideStyle = {
  ...authCardStyle,
  maxWidth: "580px",
};

export const footerLinks = {
  mt: 2,
  display: "flex",

  "& a": {
    height: "25px",
    width: "25px",
    mr: 2,
    textAlign: "center",
  },
};

export const hasMoreButtonWrapper = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "6px",
  width: "100%",
  mt: 2,
};

export const hasMoreButton = {
  height: "32px",
  minWidth: "32px",
  padding: "0 6px",
  border: "1px solid rgba(145, 158, 171, 0.32)",
  color: blackOne,
};

export const dateRangeButton = {
  width: "150px",
  justifyContent: "space-between",
  padding: "10px",
  border: "1px solid rgba(145, 158, 171, 0.32)",
  color: palette.blackOne,
  fontWeight: "400",
};

export const dateRangeInput = {
  position: "absolute",
  bottom: 0,
  left: 0,
  zIndex: -100,
  opacity: "0",
};

export const planDetailsStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  gap: "10px",
  flexWrap: "wrap",

  [customTheme.breakpoints.down("sm")]: {
    flexDirection: "column",
    gap: "16px",
    alignItems: "flex-start",
  },
};

// Portal billing plan card stats. Below the portal's 768px mobile breakpoint the
// four stats drop from a single row into a 2x2 grid rather than one tall column,
// so Subscription/Status and Protected Since/Next Billing Date stay paired.
export const subscriptionPlanDetailsStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  gap: "10px",
  flexWrap: "wrap",

  [customTheme.breakpoints.down(768)]: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    alignItems: "flex-start",
    gap: "24px 16px",
  },
};

export const StatusFilterAdminWrapper = {
  "& .MuiFormControl-root": {
    width: "150px",
    color: "red",

    [customTheme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
};

export const contactOptInButtonStyle = {
  px: 5,
  py: 1.6,
  fontSize: 16,
  borderRadius: 3,
  textTransform: "none",
  fontWeight: 700,
};

export const inviteInfoStyle = {
  backgroundColor: "#F4F6F8",
  borderRadius: 4,
  p: 3,
  textAlign: "center",
  mb: 4,
};

export const unbreakableTextStyle = {
  whiteSpace: "nowrap",
  display: "inline-block",
  maxWidth: "100%",
};

export const contactFeatureStyle = {
  width: 40,
  height: 40,
  borderRadius: "50%",
  backgroundColor: "#E3F2FD",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "primary.main",
};

export const promoButtonStyle = {
  backgroundColor: "#F4F6F8",
  borderRadius: 4,
  p: 3,
  textAlign: "center",
  mb: 4,
  border: "1px dashed",
  borderColor: "primary.main",
};

export const supStyle = { '& sup': { fontSize: '0.55em', position: 'relative' as const, lineHeight: 0 } };

/* Transaction history table (billing tab). On mobile the narrow columns broke
   "Payment Method", "Last 4 Digits" and "Credit Card" onto two lines; the table
   container already scrolls horizontally, so one line per cell reads better. */
export const transactionHistoryHeaderCell = {
  color: blackTwo,
  whiteSpace: "nowrap",
};

export const transactionHistoryCell = {
  color: blackOne,
  whiteSpace: "nowrap",
};

/* Ring My Phone call-progress modal. On a phone the desktop sizing overflowed:
   the dialog margins plus the wrapper/card/content padding left the four-step
   stepper too little width, so "ANSWERED" was clipped and "COMPLETED" fell off
   the card. The mobile variants drop the nested padding and shrink the step
   labels and icons so all four steps fit. */
export const callModalStyle = {
  zIndex: 99999,
};

export const callModalPaperMobile = {
  margin: "8px",
  width: "calc(100% - 16px)",
  maxWidth: "100%",
};

export const callModalTitleMobile = {
  fontWeight: "bold",
  fontSize: "1.05rem",
  px: 2,
  py: 1.5,
};

export const callModalTitle = {
  fontWeight: "bold",
  fontSize: "1.25rem",
};

export const callModalBody = {
  maxWidth: 500,
  mx: "auto",
  p: 2,
};

export const callModalBodyMobile = {
  width: "100%",
  mx: "auto",
  p: 0,
};

export const callModalCard = {
  p: 2,
  borderRadius: 4,
  boxShadow: 6,
};

export const callModalCardMobile = {
  p: 0,
  borderRadius: 3,
  boxShadow: 3,
};

export const callModalCardContent = {
  textAlign: "center",
};

export const callModalCardContentMobile = {
  textAlign: "center",
  px: 1,
  py: 2,

  "&:last-child": { pb: 2 },
};

export const callModalStatusText = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 1,
};

export const callModalStatusTextMobile = {
  ...callModalStatusText,
  gap: 0.5,
  fontSize: "1rem",
};

export const callModalStepper = {
  mt: 3,
};

export const callModalStepperMobile = {
  mt: 2,
  px: 0,

  "& .MuiStep-root": { px: 0.25 },
  "& .MuiStepLabel-label": { fontSize: "10px", marginTop: "4px", whiteSpace: "nowrap" },
  "& .MuiStepLabel-iconContainer .MuiSvgIcon-root": { fontSize: "20px" },
  "& .MuiStepConnector-root": { top: "10px" },
};

export const callModalAppWarning = {
  borderRadius: 2,
  backgroundColor: "rgba(255, 193, 7, 0.1)",
  border: "1px solid #ff9800",
};

export const callModalAppWarningMobile = {
  ...callModalAppWarning,

  "& .MuiTypography-root": { fontSize: "12px" },
};

// Billing step header — on desktop the back button floats over the centred
// title; on mobile it stacks above the title so it never crowds the heading.
export const billingStepHeader = {
  position: "relative" as const,
  width: "100%",
  mt: 2,
  mb: 4,
  textAlign: "center" as const,
};

export const billingStepHeaderMobile = {
  display: "flex",
  flexDirection: "column" as const,
  width: "100%",
  textAlign: "center" as const,
};

export const billingStepBackButton = {
  position: "absolute" as const,
  left: 4,
  top: 8,
  p: 1,
  backgroundColor: "rgba(0,0,0,0.08)",
  borderRadius: "50%",

  "&:hover": { backgroundColor: "rgba(0,0,0,0.15)" },
};

// Terms-agreement row in the billing summary. On paid plans the promo-code row
// below it supplies the gap before "Complete Checkout"; the free plan has no
// promo row, so it carries the spacing itself.
export const billingTermsRow = {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "flex-start",
};

export const billingTermsRowFreePlan = {
  ...billingTermsRow,
  mb: "24px",
};

export const billingStepBackButtonMobile = {
  alignSelf: "flex-start",
  mb: 2,
  p: 0.5,
  backgroundColor: "rgba(0,0,0,0.08)",
  borderRadius: "50%",

  "&:hover": { backgroundColor: "rgba(0,0,0,0.15)" },
};

/* Desktop plan card in BillingStepOne — a tighter vertical rhythm than the
   original, which made the card roughly 30% shorter. The free plan's icon
   spacer stands in for the standard card's monthly/annual toggle block, so the
   two cards stay level. */
export const planCardWrapperWeb = {
  ...billingCardWrapper,
  padding: "16px 40px 10px 40px",
  width: "100%",
  display: "flex",
  flexDirection: "column",
};

export const planCardTitleWeb = {
  textTransform: "uppercase",
  color: blackTwo,
  marginBottom: "8px",
  fontWeight: "700",
};

/* The price used to be a fixed 130px box with the currency and the "/ Month"
   suffix absolutely positioned over it, which left the slash touching the
   amount — and no offset could fix it for the free plan, whose "Free" fills the
   whole box. It is a baseline-aligned row instead, so the gaps are real
   spacing that adapts to the text width. */
export const planCardPriceRowWeb = {
  position: "relative",
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-end",
  margin: "auto",
  marginBottom: "12px",
};

export const planCardCurrencyWeb = {
  alignSelf: "flex-start",
  paddingTop: "6px",
  marginRight: "2px",
};

export const planCardPriceWeb = {
  color: blackOne,
  fontWeight: "700",
};

export const planCardPriceMultiPlanWeb = {
  ...planCardPriceWeb,
  paddingBottom: "29px",
};

export const planCardPriceSuffixWeb = {
  paddingBottom: "12px",
  marginLeft: "5px",
  whiteSpace: "nowrap",
};

export const planCardPromoWeb = {
  color: primaryMain,
  marginBottom: "8px",
};

// The plan SVGs are sized down through their height so the viewBox scales with
// them, keeping the card short without negative margins.
export const planCardIconWeb = {
  lineHeight: 0,

  "& svg": { height: "78px", width: "auto" },
};

export const planCardIconFreeWeb = {
  lineHeight: 0,

  "& svg": { height: "58px", width: "auto" },
};

// Mirrors planCardToggleWrapperWeb + planCardTaxNoteWeb, which the free plan
// does not render.
export const planCardFreeIconSpacerWeb = {
  paddingBottom: "74px",
};

export const planCardFreeIconSpacerCollapsedWeb = {
  paddingBottom: "11px",
};

export const planCardToggleWrapperWeb = {
  marginBottom: "8px",
};

export const planCardTaxNoteWeb = {
  marginTop: "8px",
  color: blackTwo,
};

export const planCardSelectButtonWeb = {
  marginTop: "16px",
  marginBottom: "12px",
};
